import uniqid from 'uniqid';
import { Cafe, ClientCafe, Order, OrderLog, Worker } from '../../apiTypes';
import { createBatch } from '../../utils/api';
import getDiscount from '../../utils/getDiscount';

type Props = {
  cafe: DbDocument<Cafe>;
  order: DbDocument<Order>;
  worker: DbDocument<Worker>;
  client: DbDocument<ClientCafe> | null;
};

export const changeClient = async ({ order, worker, cafe, client }: Props) => {
  if (worker) {
    const batch = createBatch();

    const discount = getDiscount(client, cafe.loyalty);

    const orderLog: OrderLog = {
      time: Date.now(),
      workerId: worker.id,
      workerName: worker.name,
      type: 'changeClient',
      state: {
        workerId: order.workerId,
        workerName: order.workerName,
        tableId: order.tableId,
        tableName: order.tableName,
        clientId: client?.id || '',
        clientName: client?.name || '',
        discount,
        items: order.items,
        paid: order.paid,
        status: order.status || null,
        delivery: order.delivery || null,
      },
    };

    batch.update<Order>(`cafes/${cafe.id}/orders/${order.id}`, {
      clientId: client?.id || '',
      clientName: client?.name || '',
      discount,
    });

    batch.set<OrderLog>(`cafes/${cafe.id}/orders/${order.id}/logs/${uniqid()}`, orderLog);

    await batch.commit();
  }
};
